<template>
<div class="auth-wrap">
    <div class="auth-card glass">
        <div class="auth-brand">
            <span class="brand__logo">&lt;/&gt;</span>
            <span class="brand">Entrance Exam</span>
        </div>
        <h1 class="auth-title">Welcome back</h1>
        <p class="auth-sub">Sign in to take assessments or review submissions.</p>

        <div class="field">
            <label for="login-email">Email</label>
            <input id="login-email" type="email" class="input" placeholder="you@example.com"
                :class="{'is-invalid': isEmailValid===false, 'is-valid': isEmailValid===true}"
                v-model="form.email" @input="onEmailInput" autocomplete="email">
            <div v-if="isEmailValid!=null && !isEmailValid">
                <p class="err" v-if="!$v.form.email.required">Email is required</p>
                <p class="err" v-else-if="!$v.form.email.email">Invalid email</p>
            </div>
        </div>

        <div class="field">
            <label for="login-password">Password</label>
            <input id="login-password" type="password" class="input" placeholder="••••••••"
                :class="{'is-invalid': isPasswordValid===false, 'is-valid': isPasswordValid===true}"
                v-model="form.password" @input="onPasswordInput" autocomplete="current-password"
                @keyup.enter="loginUser">
            <div v-if="isPasswordValid!=null && !isPasswordValid">
                <p class="err" v-if="!$v.form.password.required">Password is required</p>
                <p class="err" v-else-if="!$v.form.password.minLength">Password must have at least 8 characters</p>
                <p class="err" v-else-if="!$v.form.password.containsUppercase">Password must have at least one uppercase letter</p>
                <p class="err" v-else-if="!$v.form.password.containsLowercase">Password must have at least one lowercase letter</p>
                <p class="err" v-else-if="!$v.form.password.containsNumber">Password must have at least one number</p>
                <p class="err" v-else-if="!$v.form.password.containsSpecial">Password must have at least one special character</p>
            </div>
        </div>

        <button class="btn btn--primary" style="width:100%" @click="loginUser" :disabled="status=='LOADING'">
            <span class="spinner spinner--dark" v-if="status=='LOADING'"></span>
            <span v-else>Sign In</span>
        </button>

        <p class="auth-alt">New here? <a href="/register">Create an account</a></p>

        <div class="demo-creds">
            <p>Try a demo account</p>
            <button class="chip chip--btn" type="button" @click="fillDemo('examinee')">▸ Examinee demo</button>
            <button class="chip chip--alt chip--btn" type="button" @click="fillDemo('examiner')">▸ Examiner demo</button>
        </div>
    </div>
</div>
</template>
<script>
import Vue from 'vue';
import {required, minLength, email} from 'vuelidate/lib/validators'
    export default {
        name: 'LoginPage',
        data() {
            return {
                status: '',
                form: {
                    email: '',
                    password: ''
                },
                isEmailValid: null,
                isPasswordValid: null
            }
        },
        methods: {
            onEmailInput () {
                this.isEmailValid = !this.$v.form.email.$invalid;
            },
            onPasswordInput () {
                this.isPasswordValid = !this.$v.form.password.$invalid;
            },
            fillDemo(role) {
                this.form.email = role === 'examiner' ? 'examiner@demo.com' : 'examinee@demo.com';
                this.form.password = role === 'examiner' ? 'Examiner@123' : 'Examinee@123';
                this.isEmailValid = true;
                this.isPasswordValid = true;
            },
            async loginUser(){
                const credentials = {
                    email: this.form.email,
                    password: this.form.password
                }
                if (!this.$v.form.$invalid)
                {
                    this.status = 'LOADING';
                    try{
                    await this.$store.dispatch('login', credentials);
                    this.status = 'LOADED';
                    if(this.$store.getters.isAuthenticated) {
                        if(this.$store.getters.isExaminer) {
                            this.$router.push( {path: `/allassesments`});
                        }
                        else
                        this.$router.push({ path :`/assesments`})
                    }
                    else
                    {
                        Vue.$toast.error('Invalid Username Or Password');
                    }
                } catch(error){
                    this.status = 'ERROR';
                    if(error.message == '403') {
                        Vue.$toast.error('Invalid Username Or Password');
                    }
                    else
                    Vue.$toast.error('Some error ocurred');
                }
                }

                else {
                    Vue.$toast.error('Invalid Credentials');
                }
            }
        },
        validations: {
            form: {
                email: {
                    email,
                    required
                },
                password: {
                    required,
                    minLength: minLength( 8 ),
                    containsUppercase: function(value) {
                        return /[A-Z]/.test(value)
                    },
                    containsLowercase: function(value) {
                        return /[a-z]/.test(value)
                    },
                    containsNumber: function(value) {
                        return /[0-9]/.test(value)
                    },
                    containsSpecial: function(value) {
                        return /[#?!@$%^&*-]/.test(value)
                    }
                }
            }
        }
    }
</script>
